import { FaPlus, FaMinus } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import "./styles.css";

export const ProductCards = ({ products, layout, onProductSelect }) => {
  return (
    <div className={`product-cards_${layout}`}>
      {products.map((product, index) => (
        <div key={index} className={`product-card_${layout}`}>
          <div
            className={`product-img-container_${layout} ${product.selected ? "selected" : ""}`}
          >
            <img
              src={
                product.image
                  ? `data:image/png;base64, ${product.image}`
                  : "placeholder.png"
              }
              alt={product.title}
              className={`product-img_${layout}`}
            />
          </div>
          <h4 className={`product-brand ${layout}-font-style`}>
            {/* {product.brand === "" ? "\u00A0" : product.brand} */}
          </h4>
          {product.title && (
            <h4 className={`product-title ${layout}-font-style`}>
              {product.title}
            </h4>
          )}
          {product.price && <h4 className="product-price">{product.price}</h4>}

          {layout === "list" && (
            <div
              className="list-remove-product-icon-wrapper"
              onClick={() => {
                onProductSelect(product.id);
              }}
            >
              <IoMdClose />
            </div>
          )}

          {layout === "grid" && (
            <div
              className="add-to-cart-circular-icon"
              onClick={() => {
                onProductSelect(product.id);
              }}
            >
              {product.selected ? <FaMinus /> : <FaPlus />}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
